import React from 'react';

import LoadingSpinner from 'components/LoadingSpinner';

import { classNames } from 'utils/functions';
import { BUTTON_COLORS } from 'utils/enums';

const colorClasses = {
  primary: 'bg-primary-600 focus:bg-primary-500 focus:ring-primary-500 hover:bg-primary-700',
  blue: 'bg-blue-700 focus:bg-blue-600 focus:ring-blue-600 hover:bg-blue-800',
  red: 'bg-red-600 focus:bg-red-500 focus:ring-red-500 hover:bg-red-700',
};

export default function SolidButton({
  color = BUTTON_COLORS.PRIMARY,
  className = '',
  onClick,
  isLoading,
  isDisabled,
  children,
}: {
  color?: BUTTON_COLORS;
  className?: string;
  onClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  children?: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={classNames(
        className,
        colorClasses[color],
        isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        'inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm'
      )}
    >
      {isLoading ? <LoadingSpinner /> : children}
    </button>
  );
}
